import {
  calculateOrderMetrics,
  getOrderBalance,
  getOrderPaid,
  getOrderTotal,
} from './orderCalculations'

/** Same defaults as TpoAdmin OrdersChange (TotalInfo / getOrderTotal). */
const DEFAULT_ORDER_TOTAL_OPTIONS = { includeDelivery: true }

export function calcOrderItemsTotal(items = [], options = {}) {
  const metrics = calculateOrderMetrics(items, {
    includeDelivery: false,
    format: 'number',
    ...options,
  })
  return metrics.total
}

export function calcOrderTotal(order, options = {}) {
  return getOrderTotal(order, {
    ...DEFAULT_ORDER_TOTAL_OPTIONS,
    ...options,
    format: 'number',
  })
}

export function calcOrderPaid(order) {
  return getOrderPaid(order, { format: 'number' })
}

export function calcOrderBalance(order, options = {}) {
  return getOrderBalance(order, {
    ...DEFAULT_ORDER_TOTAL_OPTIONS,
    ...options,
    format: 'number',
  })
}

export function getOrderRowAmounts(order, options = {}) {
  const total = calcOrderTotal(order, options)
  const paid = calcOrderPaid(order)
  return {
    total,
    paidValue: paid,
    balance: calcOrderBalance(order, options),
  }
}

export function sumOrdersTotals(orders = [], options = {}) {
  const metrics = calculateOrderMetrics(orders, {
    ...DEFAULT_ORDER_TOTAL_OPTIONS,
    ...options,
    format: 'number',
  })
  return {
    total: metrics.total,
    paid: metrics.paid,
    balance: metrics.balance,
  }
}

export function dedupeOrdersById(orders = []) {
  const seen = new Set()
  return orders.reduce((acc, order) => {
    if (!order) return acc
    const key = order._id || order.id
    if (!key || seen.has(String(key))) return acc
    seen.add(String(key))
    acc.push(order)
    return acc
  }, [])
}
